const apiUrl = process.env.REACT_APP_API_URL;

const getVisualInspectionTypes = (token, cb) => {
    fetch(`${apiUrl}/visualinspectiontypes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getVisualInspectionTypes;
